module.exports = __webpack_public_path__ + "static/media/pt.6143c8e6.svg";